module.exports = __webpack_public_path__ + "img/stock4.75712e47.png";